import React, { FC } from 'react';

const Master: FC = () => (
  <svg width="219" height="165" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity=".7">
      <path
        opacity=".5"
        d="M181.173-40.842c-11.35 10.371-20.119 23.075-25.643 37.149-5.549 14.064-7.711 29.137-6.32 44.076 1.39 14.939 6.297 29.353 14.347 42.152l-.009.003.034.012-.005-.008c14.88-4.587 28.508-12.358 39.857-22.727s20.122-23.066 25.658-37.133c5.535-14.067 7.689-29.137 6.299-44.074-1.39-14.933-6.287-29.344-14.32-42.146l-.034-.012c-14.884 4.575-28.516 12.34-39.864 22.708Z"
        fill="#fff"
      />
      <path
        d="M155.546-3.68c5.523-14.073 14.291-26.775 25.641-37.145 11.35-10.37 24.983-18.136 39.869-22.71-9.962-15.864-24.381-28.678-41.609-36.978s-36.569-11.751-55.814-9.958c-19.245 1.794-37.616 8.758-53.014 20.098-15.398 11.34-27.2 26.597-34.06 44.029-6.86 17.431-8.5 36.333-4.73 54.546 3.768 18.212 12.792 35 26.04 48.443 13.25 13.444 30.187 23.002 48.879 27.581 18.692 4.58 38.384 3.996 56.824-1.684-8.05-12.798-12.955-27.211-14.346-42.15-1.39-14.937.771-30.009 6.32-44.072Z"
        fill="#E7EEF4"
      />
      <path
        opacity=".9"
        d="M348.085 65.356c-6.859 17.432-18.662 32.69-34.059 44.03-15.398 11.34-33.768 18.304-53.013 20.098-19.244 1.793-38.585-1.658-55.813-9.958-17.228-8.299-31.646-21.114-41.608-36.978 14.879-4.586 28.506-12.356 39.854-22.724 11.348-10.369 20.12-23.064 25.656-37.13 5.535-14.066 7.689-29.135 6.298-44.07-1.39-14.937-6.288-29.35-14.324-42.152 18.44-5.68 38.131-6.264 56.823-1.685 18.691 4.58 35.629 14.138 48.878 27.581 13.248 13.444 22.272 30.231 26.04 48.443 3.768 18.212 2.128 37.114-4.732 54.545Z"
        fill="#fff"
      />
    </g>
  </svg>
);

export default Master;
